import { useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import Segmented from '@/components/base/Segmented';
import CashierSection from './components/CashierSection';
import AdminSection from './components/AdminSection';

export default function UsersPage() {
  const { profile } = useAuth();
  const isSuperAdmin = profile?.role === 'super_admin';
  const [tab, setTab] = useState<'cashiers' | 'admins'>('cashiers');

  const options = [
    { value: 'cashiers', label: 'Cajeros' },
    ...(isSuperAdmin ? [{ value: 'admins', label: 'Administradores' }] : []),
  ];

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">Usuarios</h1>
          <p className="mt-1 text-foreground-600">
            Administra los cajeros (acceso por código) y los administradores (acceso por correo y
            contraseña).
          </p>
        </div>
      </div>

      <div className="mt-6">
        <Segmented
          options={options}
          value={tab}
          onChange={(v) => setTab(v as 'cashiers' | 'admins')}
        />
      </div>

      <div className="mt-6">{tab === 'cashiers' ? <CashierSection /> : <AdminSection />}</div>
    </div>
  );
}